import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Alert,
  Spinner,
  Table,
  OverlayTrigger,
  Tooltip,
  Button,
  Card,
} from "react-bootstrap";
import { useHistory } from "react-router-dom";
import moment from "moment";

import { getFuncFichaEmpleado } from "../../../redux/func_ficha_empleados/actions";
import CustomNavbar from "../../../components/CustomNavbar";
import SidebarDashboard from "../../../components/SidebarDashboard";
import UserHeadDetail from "../../../components/UserHeadDetail";
import UserHeadDetailMenu from "../../../components/UserHeadDetailMenu";

import {
  getCapacitaciones,
  getBienvenida,
} from "../../../redux/on&offBoarning/capacitacion/actions";

const CapacitacionList = (props) => {
  //Redux
  const dispatch = useDispatch();
  const history = useHistory();

  const userN = useSelector((store) => store.auth.username);

  const data = useSelector((store) => store.funcTabEmployeed.ficha_empleado);
  const loading = useSelector(
    (store) => store.funcTabEmployeed.loadingFicha_Empleado
  );

  const { capacitacionList, capacitacionListLength, loadingList } = useSelector(
    (store) => store.capacitacion
  );

  capacitacionList.sort((a, b) => {
    return moment(a.fecha_fin) - moment(b.fecha_fin);
  });

  useEffect(() => {
    dispatch(
      getFuncFichaEmpleado(
        props.match.params.id,
        parseInt(props.match.params.type)
      )
    );
    if (userN !== "") {
      dispatch(
        getCapacitaciones({
          filter: userN,
          tipo_busqueda: "empleado",
          tipo_workflow: "[1]",
        })
      );
    }
  }, [dispatch, props.match.params.id, props.match.params.type, userN]);

  const [show, setShow] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);
  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container mt-3 mb-3">
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            <>
              <UserHeadDetail data={data} type={props.match.params.type} />
              <div className="my-4">
                <UserHeadDetailMenu
                  id={props.match.params.id}
                  type={props.match.params.type}
                />
                <div className="mt-4 mb-3">
                  <div className="d-flex aling-items-center justify-content-between px-2">
                    <h5 className="font-weight-bold text-uppercase m-0">
                      <i
                        className="flex-wrap material-icons"
                        style={{ fontSize: "2rem", marginTop: "-.5rem" }}
                      >
                        edit_calendar
                      </i>
                      &nbsp;Inducción
                    </h5>
                    <div>
                      <span className="text-muted mr-3">
                        <i className="material-icons">vpn_key</i> Código:{" "}
                        {data.codigo}
                      </span>
                      <span className="text-muted mr-3">
                        <i className="material-icons">timer</i> Antigüedad:{" "}
                        {parseInt(data.antiguedad_laboral) < 1
                          ? ` ${parseInt(data.antiguedad_laboral)} meses`
                          : ` ${parseInt(
                              parseInt(data.antiguedad_laboral) / 12
                            )} años`}
                        {Math.floor(
                          (parseInt(data.antiguedad_laboral) / 12 -
                            parseInt(parseInt(data.antiguedad_laboral) / 12)) *
                            12
                        ) > 0
                          ? ` ${Math.floor(
                              (parseInt(data.antiguedad_laboral) / 12 -
                                parseInt(
                                  parseInt(data.antiguedad_laboral) / 12
                                )) *
                                12
                            )} meses`
                          : null}
                      </span>
                      <span className="text-muted">
                        <i className="material-icons">moving</i>{" "}
                        {data.Relacion_Laboral_List
                          ? data.Relacion_Laboral_List[0].descripcion
                          : "No ingresado aún"}
                      </span>
                    </div>
                  </div>
                  <hr className="mb-3" />
                  {loadingList ? (
                    <div className="d-flex justify-content-center">
                      <Spinner
                        animation="border"
                        role="status"
                        className="d-flex justify-content-center"
                      />
                    </div>
                  ) : capacitacionListLength === 0 ? (
                    <Alert className="my-4" variant="info">
                      Aún no tiene no tiene proceso de capacitación asignado
                    </Alert>
                  ) : (
                    // <Card class="shadow-sm">
                    <div class="table-responsive">
                      <Table striped>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>WorkFlow</th>
                            <th>Responsable</th>
                            <th>Email responsable</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {capacitacionList.map((item, index) => (
                            <tr>
                              <td>{index + 1}</td>
                              <td>{item.nombre}</td>
                              <td>
                                {item.datos_responsable[0].first_name}{" "}
                                {item.datos_responsable[0].last_name}
                              </td>
                              <td>{item.datos_responsable[0].email}</td>
                              <td>
                                <OverlayTrigger
                                  placement="left"
                                  overlay={
                                    <Tooltip {...props}>
                                      Seleccionar WorkFlow
                                    </Tooltip>
                                  }
                                >
                                  <Button
                                    size="sm"
                                    variant="primary"
                                    type="button"
                                    className="btn shadow-sm rounded px-2"
                                    onClick={() => {
                                      dispatch(
                                        getBienvenida(
                                          {
                                            username: userN,
                                            workflow_id: item.id,
                                          },
                                          history,
                                          item,
                                          item.tipo_workflow,
                                          props.match.params.type
                                        )
                                      );
                                    }}
                                  >
                                    <i className="material-icons">
                                      double_arrow
                                    </i>
                                  </Button>
                                </OverlayTrigger>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                    // </Card>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default CapacitacionList;
